import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
// import * as auth from "../_redux/authRedux";
import { RESET_PASSWORD } from "../_redux/authCrud";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";

const initialValues = {
  password: "",
  changepassword: "",
};

let URL = process.env.REACT_APP_BASE_URL || "http://localhost:4000";

function ResetPassword(props) {
  const history = useHistory();
  const { intl, location } = props;
  let token = "";
  if (location.search && location.search.startsWith("?token")) {
    token = location.search.split("=")[1];
  } else {
    history.push("/auth/login");
  }

  const [resetPassword] = useMutation(RESET_PASSWORD);
  const [isRequested, setIsRequested] = useState(false);
  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        "Password is a required field"
      ),
    changepassword: Yup.string()
      .required(
        "Confirm Password is a required field"
      )
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password and Confirm Password didn't match"
        ),
      }),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      await handleUpdatePassword(values);
      setSubmitting(false);
      // resetPassword({
      //   variables: {
      //     resetPasswordPassword: values.password,
      //     resetPasswordToken: token,
      //   },
      // })
      //   .then(() => setIsRequested(true))
      //   .catch(() => {
      //     setIsRequested(false);
      //     setSubmitting(false);
      //     setStatus(
      //       intl.formatMessage(
      //         { id: "Something went wrong. Please try again" },
      //         { name: values.email }
      //       )
      //     );
      //   });
    },
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleVerifyToken = async () => {
    setLoading(true);
    try{
      let response = await axios.post(`${URL}/verifyForgetToken`, { token });
    }catch(error){
      let errorMessage = error.response ? error.response.data.message : "Something went wrong";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
      setError(errorMessage);
    }finally{
      setLoading(false);
    }
  }

  const handleUpdatePassword = async (values) => {
    try{
      let response = await axios.post(`${URL}/resetPasswordByToken`, {
        token,
        password: values.password
      });
      let successMessage = response.data.message || "Password updated successfully";
      Swal.fire({
        title: "Success",
        text: successMessage,
        icon: "success",
        confirmButtonText: "OK",
      });
      history.push("/auth/login")
      setIsRequested(true);
    }catch(error){
      let errorMessage = error.response ? error.response.data.message : "Something went wrong";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
      setError(errorMessage);
    }
  }
    

  React.useEffect(() => {
    handleVerifyToken()
  }, []);

  if(loading){
    return <div className="loading-spinner">
      <CircularProgress
        size="20px"
        style={{ color: "#3783e7" }}
      />
    </div>;
  }
  if(error) {
    return (
      <div className="error-message">
        <p>{error}</p>
        <Link to="/auth/login">Go back to login</Link>
      </div>
    );
  }

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">Reset password</h3>
            <div className="text-muted font-weight-bold">
              Enter a new password
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}

            {/* begin: Password */}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="New Password"
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>
            {/* end: Password */}

            {/* begin: Confirm Password */}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Confirm Password"
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "changepassword"
                )}`}
                name="changepassword"
                {...formik.getFieldProps("changepassword")}
              />
              {formik.touched.changepassword && formik.errors.changepassword ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.changepassword}
                  </div>
                </div>
              ) : null}
            </div>
            {/* end: Confirm Password */}

            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                Submit
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  Cancel
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default ResetPassword;
// export default injectIntl(connect(null, auth.actions)(ResetPassword));
